import { Button, Flex } from "antd";
import { type ReactNode } from "react";
import Title from "../../../../components/ui/Title";
import { cn } from "../../../../utils/global.utils";
import { enToBnNumber } from "../../../../utils/number.utils";

type Props = {
  children?: ReactNode;
  progress: number;
  totalLessons: number;
  completedLessons: number;
  isCompletedLoading?: boolean;
  isNextDisabled?: boolean;
  isCompleted: boolean;
  onComplete: () => void;
  onNext: () => void;
  onPrevious: () => void;
  showPrevious?: boolean;
  showNext?: boolean;
  hideCompleteButton?: boolean;
  isLastStep?: boolean;
};

export default function ContentWrapper({
  children,
  progress,
  // isCompleted,
  // isCompletedLoading,
  isNextDisabled,
  // onComplete,
  onNext,
  onPrevious,
  showPrevious = true,
  showNext = true,
  // hideCompleteButton = false,
  isLastStep = false,
}: Props) {
  return (
    <div>
      {/* Header action */}
      <Flex
        justify="space-between"
        align="center"
        wrap
        className="pb-6 mb-6 border-b border-theme-zinc-200"
      >
        {/* <Title className="text-2xl text-theme-primary">
          অগ্রগতি: {enToBnNumber(totalLessons)} এর মধ্যে{" "}
          {enToBnNumber(completedLessons)} ({enToBnNumber(progress)}%)
        </Title> */}
        <Title className="text-2xl text-theme-primary">
          অগ্রগতি: ({enToBnNumber(progress)}%)
        </Title>

        {/* {!hideCompleteButton && (
          <Button
            size="large"
            onClick={onComplete}
            disabled={isCompleted}
            loading={isCompletedLoading}
            className={cn(
              "rounded-full text-sm font-medium min-w-28 h-10 relative -top-[1px] !text-white !bg-theme-red-500 border-none hover:!bg-theme-red-600 disabled:opacity-50"
            )}
          >
            কমপ্লিট মার্ক করুন
          </Button>
        )} */}
      </Flex>

      {/* Main Content */}
      {children}

      {/* Footer action */}
      <Flex
        justify="space-between"
        align="center"
        wrap
        className="pt-6 my-6 border-t border-theme-zinc-200"
      >
        {showPrevious && (
          <Button
            variant="outlined"
            type="text"
            size="middle"
            onClick={onPrevious}
            className={cn(
              "rounded-lg min-w-24",
              "!text-theme-primary !bg-[#E9F2F2] hover:!bg-[#d3e6e6]",
            )}
          >
            পূর্ববর্তী
          </Button>
        )}

        {showNext && (
          <Button
            variant="outlined"
            type="primary"
            size="middle"
            onClick={onNext}
            disabled={isNextDisabled}
            className={cn("rounded-lg min-w-24 ml-auto")}
          >
            {isLastStep ? "সম্পূর্ন & পরবর্তী" : "পরবর্তী"}
          </Button>
        )}
      </Flex>
    </div>
  );
}
